import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export const CostTrend = ({ trend }) => {
  const data = trend.map((t) => ({ ...t, label: new Date(`${t.month}-01T00:00:00`).toLocaleDateString("en-GB", { month: "short" }) }));
  return (
    <div className="rounded-xl border border-border bg-card p-4" data-testid="platform-trend">
      <div className="text-sm font-medium mb-3">AI spend · last {data.length} month{data.length === 1 ? "" : "s"}</div>
      <div className="h-40">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
            <XAxis dataKey="label" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11 }} axisLine={false} tickLine={false} tickFormatter={(v) => `£${v}`} />
            <Tooltip cursor={{ fill: "hsl(var(--muted))" }} contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }}
                     formatter={(v, n) => (n === "ai_cost_gbp" ? [`£${Number(v).toFixed(2)}`, "AI cost"] : [v, "AI calls"])} />
            <Bar dataKey="ai_cost_gbp" fill="hsl(var(--primary))" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
